(() => {
  if (customElements.get('edufun-product-3d')) return;
  class EduFunProduct3D extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      this.stage = this.querySelector('[data-edufun-stage]');
      this.status = this.querySelector('[data-edufun-status]');
      this.controls = this.querySelector('[data-edufun-controls]');
      this.templates = [...this.querySelectorAll('template[data-edufun-model]')];
      this.retry = this.querySelector('[data-edufun-retry]');
      this.triggerController = new AbortController();
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-edufun-3d-open]');
        if (trigger?.getAttribute('data-edufun-3d-open') !== this.dataset.productId) return;
        event.preventDefault();
        this.opener = trigger;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        if (!this.viewer) this.loadModel(0);
      }, { signal: this.triggerController.signal, capture: true });
      this.querySelector('[data-edufun-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.opener?.focus();
      });
      this.querySelector('[data-edufun-reset]').addEventListener('click', () => {
        if (!this.viewer) return;
        this.viewer.cameraOrbit = '35deg 75deg 105%';
        this.viewer.cameraTarget = 'auto auto auto';
        this.viewer.fieldOfView = 'auto';
      });
      this.querySelectorAll('[data-edufun-zoom]').forEach(button => button.addEventListener('click', () => {
        const orbit = this.viewer?.getCameraOrbit?.();
        if (!orbit) return;
        const factor = button.dataset.edufunZoom === 'in' ? 0.8 : 1.25;
        this.viewer.cameraOrbit = `${orbit.theta}rad ${orbit.phi}rad ${orbit.radius * factor}m`;
      }));
      this.retry.addEventListener('click', () => this.loadModel(this.currentIndex || 0));
      this.querySelector('[data-edufun-select]')?.addEventListener('change', event => this.loadModel(Number(event.target.value)));
      this.activateTriggers();
      document.addEventListener('shopify:section:load', () => this.activateTriggers(), { signal: this.triggerController.signal });
    }
    activateTriggers() {
      document.querySelectorAll(`[data-edufun-3d-open="${this.dataset.productId}"]`).forEach(button => {
        button.hidden = false;
        button.parentElement.classList.add('edufun-3d-gallery');
      });
    }
    loadModel(index) {
      clearTimeout(this.timer);
      this.currentIndex = index;
      this.status.textContent = this.status.dataset.loading;
      this.retry.hidden = true;
      this.controls.hidden = true;
      this.stage.replaceChildren(this.templates[index].content.cloneNode(true));
      const viewer = this.stage.querySelector('model-viewer');
      this.viewer = viewer;
      // Product scale/variant approval is separate; no unverified AR claim in this pilot.
      viewer.removeAttribute('ar');
      viewer.removeAttribute('ios-src');
      const arSlot = document.createElement('span');
      arSlot.slot = 'ar-button';
      viewer.append(arSlot);
      this.querySelector('[data-edufun-label]').textContent = this.templates[index].dataset.label;
      const failure = () => {
        if (this.viewer !== viewer) return;
        this.status.textContent = this.status.dataset.error;
        this.retry.hidden = false;
        clearTimeout(this.timer);
      };
      viewer.addEventListener('load', () => {
        if (this.viewer !== viewer) return;
        clearTimeout(this.timer);
        this.status.textContent = '';
        this.controls.hidden = false;
        this.retry.hidden = true;
      }, { once:true });
      viewer.addEventListener('error', failure, { once:true });
      this.timer = setTimeout(failure, 45000);
      if (!customElements.get('model-viewer')) {
        if (!window.Shopify?.loadFeatures) { failure(); return; }
        Shopify.loadFeatures([{name:'model-viewer-ui', version:'1.0', onLoad:errors => { if (errors) failure(); }}]);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.triggerController?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.ready = false;
    }
  }
  customElements.define('edufun-product-3d', EduFunProduct3D);
})();
